/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_ProductInputs */

const en_create_product = /** @type {(inputs: Create_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Product`)
};

const es_create_product = /** @type {(inputs: Create_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear producto`)
};

/**
* | output |
* | --- |
* | "Create Product" |
*
* @param {Create_ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_product = /** @type {((inputs?: Create_ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_product(inputs)
	return es_create_product(inputs)
});